export default __webpack_public_path__ + "static/media/halozatosodas.d10254c3.svg";